export default __webpack_public_path__ + "static/media/SelfDriving.48b5ad77.svg";